import { StyledSection, CenteredSectionContent } from '../../styled-components/sections';
import { Separator } from './Separator';

export const SeparatorSection = () => (
  <StyledSection>
    <CenteredSectionContent>
      <Separator />
    </CenteredSectionContent>
  </StyledSection>
);
